import * as React from 'react';
import { observer } from 'mobx-react';
import { AmountBonusFieldRule } from './amountBonusFieldRule';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import { EmployeeDispatcher } from 'nomst/Stores/Decision/employee.dispatcher';
import { Amount as AmountBusinessLogic } from 'nomst/Stores/Decision/amount';
import './multiFactorBonusView.scss';
import { AmountCode } from '../../../typings/enums';
import Bonus = AmountCode.Bonus;

export interface IMultiFactorBonusViewProps {
    configuration: Configuration;
    employeeDispatcher: EmployeeDispatcher;
    employeeSourceId: string;
    bonusFieldDecisions: IBonusFieldRule[];
    amount: AmountBusinessLogic;
}

export class MultifFactorBonusView extends React.Component<IMultiFactorBonusViewProps> {

    constructor(props: IMultiFactorBonusViewProps) {
        super(props);

        this.renderBonusFieldRule = this.renderBonusFieldRule.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
    }

    render(): React.ReactNode {
        const { amount } = this.props;

        return (
            <div className="multi-factor-bonus-view">
                <div className="multi-factor-bonus-view__title">Bonus Breakdown</div>
                <div className="multi-factor-bonus-view__main-header">
                    <p>Total Earned Bonus</p>
                    <p className="multi-factor-bonus-view__total-amount">{amount.overallMultiBonusAmount}</p>
                </div>
                <div className="multi-factor-bonus-view__rules-header row">
                    <p className="col-sm-4">Weight (%)</p>
                    <p className="col-sm-5">Attainment (%)</p>
                </div>
                {amount.bonusFieldDecisions.map(rule => this.renderBonusFieldRule(rule))}
                <div className="multi-factor-bonus-view__save">
                    <button
                        onClick={this.handleSaveClick}
                        className="pxl-btn pxl-btn--primary"
                    >
                    Save
                    </button>
                </div>
            </div>
        );
    }

    private renderBonusFieldRule(bonusFieldRule: IBonusFieldRule): React.ReactNode {
        return (
            <AmountBonusFieldRule
                key={bonusFieldRule.fieldIndex}
                bonusFieldRule={bonusFieldRule}
                amount={this.props.amount}
            />
        );
    }

    private async handleSaveClick(): Promise<void> {
        const { masterAccountId, cycleId } = this.props.configuration;
        const bonusAmount = this.props.configuration.getCycleBudgetField(Bonus);
        const budgetCycleId = bonusAmount.budgetCycleId;
        const { employeeSourceId, employeeDispatcher, amount } = this.props;

        return await employeeDispatcher.dispatchSaveEmployeeDecisions(
            masterAccountId, cycleId, budgetCycleId ?? 0, employeeSourceId, amount.bonusFieldDecisions);
    }
}

export default observer(MultifFactorBonusView);